<div class="flex-item-container" *ngIf="itinerary">
  <div class="fixed-width-label">
    <span routeItineraryDottedLineIcon [svgIconPath]="locationImage" [iconClass]="locationIcon">{{
      getTimeString()
    }}</span>
  </div>
  <div class="flex-content-container">
    <div>
      {{ locationName }} <span class="text-ds-light">{{ supplierPostcode }}</span>
    </div>
  </div>
</div>
